import gemeenteApi from "../../../api/gemeenteApi";
import transactionApi from "../../../api/transactieApi";
import referentieApi from "../../../api/shared/referentieApi";
import { TransactionDomainEnum, UserTypes } from "../../../constants/DomainConstants";
import mergeDeep from "../../../util/mergeDeep";
import redirector from "../../../util/redirector";
import { orderByPropertyName } from "../../../util/orderBy.js";
import SecurityApi from "../../../api/shared/securityApi";

export default class GemeenteOverzichtPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    openExportModal() {
        const context = this.context;
        context.setState({
            exportModalIsOpen: true,
            gemeenteEmailAdres: context.props.gemeenteEmailAdres
        });
    }

    closeExportModal() {
        const context = this.context;
        context.setState({
            exportModalIsOpen: false
        });
    }


    exportSportclubs() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const props = context.props;
        const ondernemingsnummer = props.gemeenteOndernemingsnummer;
        let email = context.state.gemeenteEmailAdres;

        if (email) {
            gemeenteApi.createExportRequestForSportclubs({ ondernemingsnummer: ondernemingsnummer, email: email })
                .then(() => {
                    ajaxActions.ended();
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    context.props.throwException(ex);
                });
        }

        context.setState({
            exportModalIsOpen: false
        });
    }

    init() {
        this.loadUserSession();
        this.context.props.setUserType(UserTypes.GEMEENTEMEDEWERKER);
    }

    setGemeente() {
        const context = this.context;
        const state = context.state;
        const props = context.props;
        const gemeenteId = props.gemeentes.length === 1 ? props.gemeentes[0].id : state.selectedGemeenteId;
        const gemeente = mergeDeep({}, props.gemeentes.find(f => f.id === gemeenteId));
        const ajaxActions = context.props.ajaxActions;

        if (gemeente && gemeente.id) {
            ajaxActions.started();

            SecurityApi.switchOrganisatie(gemeente.ondernemingsnummer).then(() => {
                ajaxActions.ended();
                this.getDomeinenEnInfras();
            })
                .catch((ex) => {
                    context.props.throwException(ex);
                });

            props.setCurrentOrganisation(gemeente);

            let activePage = state.filter ? state.filter.pageNo : 1;
            this.loadSportclubPage(activePage, "Prioriteit");
            this.loadOpenAanvragen();
            this.findSpakkiUserId(gemeente.ondernemingsnummer);
        }
        else {
            context.setState({
                sportclubModels: [],
                openAanvragenModels: [],
                filter: {
                    pageNo: 1,
                    pageSize: 50,
                    ascending: true,
                    orderBy: "Prioriteit",
                    naam: null,
                    sporttak: null,
                    sportdomein: null,
                    sportinfrastructuur: null
                }
            });
        }
    }

    loadLayout() {
        const context = this.context;
        const props = context.props;
        props.loadOverzichtLayout();
    }

    loadUserSession() {
        const context = this.context;
        const props = context.props;

        if (props.gemeentes.length === 1 || props.gemeenteId) {
            if (props.gemeenteId) {
                context.setState({
                    selectedGemeenteId: props.gemeenteId
                }, () => {
                    this.setGemeente();
                });
            }
            else {
                this.setGemeente();
            }
        }
    }

    change(event) {
        const property = event.target.name;
        const value = event.target.value;
        const context = this.context;
        let filter = context.state.filter;

        if (property in filter) {
            filter[property] = value;

            if (property === "sportdomein" && !value) {
                filter.sportinfrastructuur = null;
            }

            context.setState({
                filter: filter
            });
        }
        else {
            context.setState({
                [property]: value,
            }, () => {
                if (property === "selectedGemeenteId") {
                    this.setGemeente();
                }
            });
        }
    }

    getDomeinenEnInfras() {
        const context = this.context;
        const state = context.state;
        const props = context.props;
        const ajaxActions = context.props.ajaxActions;
        const gemeenteId = props.gemeentes.length === 1 ? props.gemeentes[0].id : state.selectedGemeenteId;

        referentieApi.getDomeinenEnInfrasByGemeente(gemeenteId)
            .then((response) => {
                ajaxActions.ended();

                const domeinen = response.data.sportDomeinen.map(dom => {
                    return {
                        label: dom.naam,
                        value: dom.id
                    };
                });
                const infrastructuren = response.data.sportInfrastructuren.map(infra => {
                    return {
                        label: infra.naam,
                        value: infra.sisId,
                        domeinId: infra.domeinId
                    };
                });

                context.setState({
                    domeinen: domeinen,
                    infrastructuren: infrastructuren
                });
            })
            .catch((ex) => {
                context.props.throwException(ex);
            });
    }

    search() {
        this.loadSportclubPage(1, "Prioriteit");
    }

    loadSportclubPage(pageNummer, orderBy, onSort) {
        const context = this.context;
        const state = context.state;
        const props = context.props;
        const ajaxActions = context.props.ajaxActions;
        const gemeenteId = props.gemeentes.length === 1 ? props.gemeentes[0].id : state.selectedGemeenteId;
        const filter = state.filter;
        filter.pageNo = pageNummer ? pageNummer : 1;

        ajaxActions.started();
        gemeenteApi.getSportclubsByGemeenteByFilter(gemeenteId, filter)
            .then((response) => {
                ajaxActions.ended();

                let models = response.data.items;
                filter.pageNo = response.data.pageNo;
                filter.pageSize = response.data.pageSize;
                let totalItems = response.data.totalItems;
                let totalPages = response.data.totalPages;

                context.setState({
                    sportclubModels: models,
                    filter: filter,
                    totalItems,
                    totalPages
                });
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    changePageSize(pageSize) {
        let filter = mergeDeep({}, this.context.state.filter);
        filter.pageSize = pageSize;
        this.context.setState({
            filter: filter
        }, () => this.loadSportclubPage());
    }

    editSportclub(id, isNew, isReadonly) {
        const ajaxActions = this.context.props.ajaxActions;
        const gemeenteId = this.context.props.gemeentes.length === 1 ? this.context.props.gemeentes[0].id : this.context.state.selectedGemeenteId;

        transactionApi.getNewOrExistingTransactie(TransactionDomainEnum.SPORTORGANISATIE, id, gemeenteId, isReadonly)
            .then((response) => {
                ajaxActions.ended();

                this.redirectToEditSportclub(id, response.data, isNew, isReadonly);
            })
            .catch((ex) => {
                ajaxActions.failed();
            });
    }

    redirectToEditSportclub(id, transactieId, isNew, isReadonly) {
        const context = this.context;
        context.props.setActiveSportclub(id, transactieId, isReadonly, isNew);

        redirector.goTo(`/sportorganisatie/organisatie/${transactieId}`);
    }


    loadOpenAanvragen() {
        const context = this.context;
        const state = context.state;
        const props = context.props;
        const ajaxActions = props.ajaxActions;
        const gemeenteId = props.gemeentes.length === 1 ? props.gemeentes[0].id : state.selectedGemeenteId;

        ajaxActions.started();

        gemeenteApi.getOpenAanvragenByGemeente(gemeenteId)
            .then((response) => {
                ajaxActions.ended();

                context.setState({
                    openAanvragenModels: response.data
                });
            })
            .catch(() => {
                ajaxActions.failed();
            });
    }

    scrollToAanvragen() {
        document.getElementById("aanvragenForm").scrollIntoView();
    }

    link() {
        redirector.goTo("/gemeente/linkOrganisatie");
    }

    toonKaart() {
        const context = this.context;
        const props = context.props;
        const state = context.state;
        const ajaxActions = props.ajaxActions;
        const gemeenteId = props.gemeentes.length === 1 ? props.gemeentes[0].id : state.selectedGemeenteId;

        if (!state.markerModels || !state.markerModels.length) {
            ajaxActions.started();

            gemeenteApi.listSportclubsMarkers(gemeenteId)
                .then((response) => {
                    ajaxActions.ended();

                    const markerModels = orderByPropertyName(response.data, "naam");

                    context.setState({
                        showMap: true,
                        markerModels: markerModels
                    });
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    props.throwException(ex);
                });
        }
        else {
            context.setState({
                showMap: true
            });
        }
    }

    findSpakkiUserId(ondernemingsnummer) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const props = context.props;
        const url = props.spakkiBevragingstoolUrl;

        if (ondernemingsnummer) {
            gemeenteApi.findSpakkiUserId(ondernemingsnummer)
                .then((response) => {
                    ajaxActions.ended();

                    if (response.data) {
                        context.setState({
                            spakkiUserId: response.data
                        });
                    }
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    context.props.throwException(ex);
                });
        }
    }

    cancelToonKaart() {
        const context = this.context;

        context.setState({
            showMap: false
        });
    }
}